import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updatePostCategory } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import parseError from "../../../utils/parseError";

export const useUpdatePostCategory = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutate: updateCategoryMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updatePostCategory(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Category updated successfully");
            queryClient.invalidateQueries(["post-categories"]);
            navigate("/blog/categories");
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update category");
        },
    });

    return { updateCategoryMutate, isUpdating };
};
